@defer (when schedules()) {
  @if (schedules().length) {
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Schedule</th>
          @for (scheduleDay of schedules()[0].days; track $index) {
            <th colspan="2" class="text-center">{{ scheduleDay.day }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (schedule of schedules(); track $index) {
          <tr (click)="clickSchedule(schedule)">
            <td>{{ schedule.title }}</td>
            @for (scheduleDay of schedule.days; track $index) {
              <td class="text-center on">{{ scheduleDay.timeOn ?? '-- : --' }}</td>
              <td class="text-center off">{{ scheduleDay.timeOff ?? '-- : --' }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <app-info-panel>No Schedules</app-info-panel>
  }
}

@if (schedule()) {
  <table class="table schedule">
    <thead>
      <tr>
        <th>Day</th>
        <th>On</th>
        <th>Off</th>
        <th></th>
      </tr>
    </thead>
    <tbody class="fourd">
      @for (day of schedule().days; track $index) {
        <tr>
          <td>{{ day.day }}</td>
          <td class="text-center on">
            <input class="fourd" type="time" [(ngModel)]="day.timeOn" />
          </td>
          <td class="text-center off">
            <input class="fourd" type="time" [(ngModel)]="day.timeOff" />
          </td>
          <td>
            <i class="mdi mdi-close can-click" title="Clear" (click)="clearDay(day)"></i>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
